import Box from '@mui/material/Box'

import { Badge, BadgeStatus } from '../../../data-display/badge/Badge'

type FormAutocompleteBadgeProps = {
  multiple?: boolean
  count?: number
}

export const FormAutocompleteBadge = ({
  multiple = false,
  count,
}: FormAutocompleteBadgeProps) => {
  if (!multiple || !count) {
    return null
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        right: '31px',
        top: '50%',
        transform: 'translateY(-50%)',
        pointerEvents: 'none',
      }}
    >
      <Badge status={BadgeStatus.COUNT} content={count} size="m" />
    </Box>
  )
}
